import { IconButton, Menu } from '@mui/material';
import { FunctionComponent, PropsWithChildren, useState } from 'react';

export type DropdownProps = {
  actionComponent: React.ReactNode;
};

export const Dropdown: FunctionComponent<PropsWithChildren<DropdownProps>> = (
  props,
) => {
  const { actionComponent, children } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen}>{actionComponent}</IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: (theme) => ({
            '& .MuiAvatar-root': {
              height: 32,
              ml: -0.5,
              mr: 1,
              width: 32,
            },
            '&:before': {
              bgcolor: theme.palette.primary.dark,
              content: '""',
              display: 'block',
              height: 10,
              position: 'absolute',
              right: 14,
              top: 0,
              transform: 'translateY(-50%) rotate(45deg)',
              width: 10,
              zIndex: 0,
            },
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            overflow: 'visible',
          }),
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {children}
      </Menu>
    </>
  );
};
